// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__dYfu8","middle":"Badge_middle__zqvKZ"};